module.exports = __webpack_public_path__ + "static/img/train_weight_gray.92db114.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/train_weight_gray.png
// module id = bl4T
// module chunks = 1